import { ButtonGroup } from 'modules/salaries/components/ButtonGroup/ButtonGroup';
import { BarChart } from 'modules/salaries/types/BarChart';
import { LineChart } from 'modules/salaries/types/LineChart';
import { MainChartData } from 'modules/salaries/types/MainChartData';
import { isDefined } from 'utils/functional';

import { EstimatedRangeButton } from './EstimatedRangeButton';
import {
  MainChartLegendContainer,
  StyledTooltip,
} from './MainChartLegend.styled';
import { SubmissionsButton } from './SubmissionsButton';

type MainChartLegendProps = {
  data: MainChartData;
  setData: (arg0: MainChartData) => void;
};

export function MainChartLegend({ data, setData }: MainChartLegendProps) {
  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  const activeChart = [data.lineChart, data.barChart].find(
    (c) => c && c.active,
  ).name;

  return isDefined(data) ? (
    <MainChartLegendContainer>
      <ButtonGroup
        value={activeChart}
        onSelected={(e) =>
          setData({
            ...data,
            lineChart: {
              ...(data.lineChart as LineChart),
              active: e.currentTarget.id === 'estimatedRange',
            },
            barChart: {
              ...(data.barChart as BarChart),
              active: e.currentTarget.id === 'submissions',
            },
          })
        }
      >
        <EstimatedRangeButton
          id="estimatedRange"
          disabled={!data.lineChart}
          data-qa-id="toggle-estimated-range-layer"
        >
          {isDefined(data.lineChart)
            ? 'Estimated Range'
            : 'Estimated Range Not Available'}
        </EstimatedRangeButton>
        <SubmissionsButton
          id="submissions"
          disabled={!data.barChart}
          data-qa-id="toggle-submissions-layer"
        >
          {isDefined(data.barChart)
            ? 'Submissions'
            : 'Submissions Not Available'}
          {!isDefined(data.barChart) ? (
            <StyledTooltip greyColor>
              {getText(
                "We've collected submissions related to this title and similar titles, but there are fewer than 20 submissions associated with this title. Our machine learning system can estimate an expected salary range for this title, but there are not enough submissions to show a meaningful chart.",
              )}
            </StyledTooltip>
          ) : null}
        </SubmissionsButton>
      </ButtonGroup>
    </MainChartLegendContainer>
  ) : null;
}
